import { SupabaseUpdateNotificationPreferencesRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { UpdateNotificationPreferences } from '@/shared/domain'

export function makeUpdateNotificationPreferences(): UpdateNotificationPreferences {
  return new SupabaseUpdateNotificationPreferencesRepository(makeSupabaseEdgeHttpClient()).execute
}
